var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGiftOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "25px",
    viewBox: "0 0 27 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGiftOutline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.44634337,-1.11595109 L9.04215343,2.73716892 C9.25495537,2.91558173 9.28283326,3.23272396 9.10442044,3.4455259 C9.0855257,3.46806262 9.06469014,3.48889817 9.04215343,3.50779292 C8.89933651,3.6275304 8.72142416,3.68294407 8.54612339,3.67403394 C8.54022616,3.77460687 8.50196381,3.87449012 8.43176478,3.95822004 C8.41287003,3.98075675 8.39203448,4.00159231 8.36949776,4.02048705 L3.77368771,7.87360706 C3.50783687,8.096496 3.12037654,8.096496 2.8545257,7.87360706 C2.64172376,7.69519425 2.61384587,7.37805202 2.79225868,7.16525008 C2.81115343,7.14271336 2.83198899,7.12187781 2.8545257,7.10298306 L7.45033575,3.24986305 C7.51651443,3.19437895 7.59022889,3.15270659 7.66772732,3.12484598 L3.52718136,-0.345327092 C3.31437942,-0.52373991 3.28650153,-0.840882134 3.46491435,-1.05368408 C3.48380909,-1.07622079 3.50464465,-1.09705635 3.52718136,-1.11595109 C3.7930322,-1.33884003 4.18049253,-1.33884003 4.44634337,-1.11595109 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger---plus-popup",
    transform: "translate(-482.000000, -1043.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-menu",
    transform: "translate(460.000000, 805.727086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field",
    transform: "translate(0.000000, 225.272914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icGiftOutline",
    transform: "translate(22.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9527427,25 L3.94740445,25 C3.08038404,24.9978884 2.37799087,24.295667 2.37566728,23.4286471 L2.37566728,10.9558175 C2.37566728,10.7435812 2.5477188,10.5715297 2.7599551,10.5715297 L24.140192,10.5715297 C24.3524283,10.5715297 24.5244799,10.7435812 24.5244799,10.9558175 L24.5244799,23.4286471 C24.5221563,24.295667 23.8197631,24.9978884 22.9527427,25 Z",
    id: "Shape",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14424291,11.3401053 L3.14424291,23.4286471 C3.14466661,23.8722576 3.50417825,24.2317692 3.94778874,24.2321929 L22.9527427,24.2321929 C23.3962031,24.2315575 23.7554809,23.8721078 23.7559042,23.4286471 L23.7559042,11.3401053 L3.14424291,11.3401053 Z",
    id: "Path",
    fill: "#F4F4F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9217504,11.3401053 L0.97839678,11.3401053 C0.438668217,11.3396827 0.00105895686,10.9025891 0,10.3628614 L0,7.39231655 C0.000635659985,6.85228866 0.438368687,6.41472757 0.97839678,6.41430406 L25.9217504,6.41430406 C26.4617784,6.41472757 26.8995115,6.85228866 26.9001471,7.39231655 L26.9001471,10.3628614 C26.8990882,10.9025891 26.4614789,11.3396827 25.9217504,11.3401053 Z",
    id: "Shape",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.97839678,7.18287969 C0.862665668,7.18287969 0.768575632,7.27658563 0.768575632,7.39231655 L0.768575632,10.3628614 C0.768575632,10.4785923 0.862665668,10.5722982 0.97839678,10.5722982 L25.9217504,10.5722982 C26.0374815,10.5722982 26.1315715,10.4785923 26.1315715,10.3628614 L26.1315715,7.39231655 C26.1315715,7.27658563 26.0374815,7.18287969 25.9217504,7.18287969 L0.97839678,7.18287969 Z",
    id: "Path",
    fill: "#F4F4F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6405141,10.7276183 C15.8527504,10.7276183 16.0248019,10.8964479 16.0248019,11.1047098 L16.0248019,24.5088046 C16.0248019,24.7170665 15.8527504,24.8858961 15.6405141,24.8858961 L11.259633,24.8858961 C11.0473967,24.8858961 10.8753452,24.7170665 10.8753452,24.5088046 L10.8753452,11.1047098 C10.8753452,10.8964479 11.0473967,10.7276183 11.259633,10.7276183 L15.6405141,10.7276183 Z M15.2562263,11.3401053 L11.6439208,11.3401053 L11.6439208,24.2314244 L15.2562263,24.2314244 L15.2562263,11.3401053 Z",
    id: "Shape",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(8.349754, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000",
    fillRule: "nonzero",
    transform: "translate(5.948340, 3.378828) rotate(90.000000) translate(-5.948340, -3.378828) ",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGiftOutline);
export default __webpack_public_path__ + "static/media/icGiftOutline.22b4c6a079088595c0f6811fce5211f9.svg";
export { ForwardRef as ReactComponent };